import { RestrictedAccountObjectDto } from "../restricted-account-object/restricted-account-object.dto";
import { DtoInclude, DtoIncludeNumber, DtoRef } from "../../../core/store/dto/dto";

export class LookupDto extends RestrictedAccountObjectDto {
    @DtoInclude
    title: string;
    @DtoInclude
    content: string;
    @DtoIncludeNumber
    sequence: number;
    @DtoRef
    lookupType: string;
}



// WEBPACK FOOTER //
// ./src/vas/business-objects/lookup/lookup.dto.ts